"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityNotificationConfigSchema = exports.MAX_ACTIVITY_NOTIFICATION_RECIPIENTS = void 0;
const yup = __importStar(require("yup"));
/** Generous ceiling that prevents unbounded growth without constraining realistic fund admin use. */
exports.MAX_ACTIVITY_NOTIFICATION_RECIPIENTS = 100;
const EMAIL_INVALID = "Each recipient must be a valid email address";
const TOO_MANY = `A maximum of ${exports.MAX_ACTIVITY_NOTIFICATION_RECIPIENTS} recipients can be configured`;
const LIST_REQUIRED = "recipientEmails is required";
/**
 * PUT /company/:companyId/activity-notifications
 *
 * Validates format and list size only. Trimming, lower-casing, and case-insensitive
 * de-duplication happen in the controller before persisting (FR-002).
 *
 * `recipientEmails` is required: an explicit empty array clears the list, but an absent
 * key is rejected so a partial/empty body can never silently wipe the configured recipients.
 */
exports.ActivityNotificationConfigSchema = yup.object().shape({
    recipientEmails: yup
        .array()
        .of(yup.string().trim().email(EMAIL_INVALID).required(EMAIL_INVALID))
        .max(exports.MAX_ACTIVITY_NOTIFICATION_RECIPIENTS, TOO_MANY)
        .required(LIST_REQUIRED),
});
//# sourceMappingURL=ActivityNotificationConfigSchema.js.map